import React, { useEffect, useState } from 'react';
import '../styles/sonstige/feedback.css';


function Feedback() {
    const [feedbacks, setFeedbacks] = useState([]);

    useEffect(() => {
        fetch('https://nurleder.de/api/feedback-text/')
            .then(res => res.json())
            .then(data => {
                // Optional: Neueste zuerst
                const sorted = [...data].sort((a, b) => new Date(b.erstellt_am) - new Date(a.erstellt_am));
                setFeedbacks(sorted);
            })
            .catch(err => console.error("Fehler beim Laden der Feedbacks:", err));
    }, []);

    return (
        <section className="kontakt-section">
            <div className="kontakt-container">
                <div className="kontakt-text">
                    <h1>⭐ Kundenstimmen</h1>
                    <h2>Teilen Sie Ihre Meinung mit anderen!</h2>
                    <p><strong>
                        Ihre Erfahrung ist uns wichtig – und hilft auch anderen Kundinnen und Kunden,
                        sich ein Bild von unseren handgefertigten Produkten zu machen.<br /><br />
                        Ob Lob, Anregung oder ehrliches Feedback – schreiben Sie uns, was Ihnen gefallen hat
                        oder was wir besser machen können.<br /><br />
                        🧵 Vielen Dank für Ihre Unterstützung – Ihre Meinung zählt!
                    </strong></p>

                    <a href="/feedback-text" className="mail-button">
                        ✏️ Schreiben Sie uns
                    </a>

                    <hr className="divider" />

                    <div className="feedback-liste">
                        {feedbacks.length === 0 ? (
                            <p>🕐 Noch keine Bewertungen vorhanden.</p>
                        ) : (
                            feedbacks.map((fb, index) => (
                                <div key={index} className="feedback-item">
                                    <p><strong>{fb.name}:</strong></p>
                                    <p className="feedback-message">"{fb.message}"</p>
                                    {fb.rating > 0 && (
                                        <p className="feedback-rating">Bewertung: {"★".repeat(fb.rating)}{"☆".repeat(5 - fb.rating)}</p>
                                    )}
                                    <hr />
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Feedback;
